
$.eachComponent('#menu > div', function(context) {
    $(context).on('click','.menu-items',function(e){
        if(!$(e.target).is('a')){
            $(this).find('a.menu-link').click();
        }
    });
});